export default __webpack_public_path__ + "static/media/dealer_methods_logo.png";